export function FloatingStandaloneBanner() {
  return (
    <div
      style={{
        position: 'fixed',
        top: 8,
        left: '50%',
        transform: 'translateX(-50%) rotate(-2deg)',
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          display: 'flex',
          height: 25,
          padding: '0 6px',
          backgroundColor: '#ffb101',
          backgroundImage: 'repeating-linear-gradient(-55deg, #000, #000 20px, #ffb101 20px, #ffb101 40px)',
        }}
      >
        <span
          style={{
            margin: 'auto',
            padding: '0 5px',
            backgroundColor: '#ffb101',
            border: '1px solid #000',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
          }}
        >
          Standalone
        </span>
      </div>
    </div>
  );
}
